import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FilterState } from '@progress/kendo-angular-treeview';

import { ITree } from "bi-interfaces/lib/interfaces/ITree";
import { of } from 'rxjs';

@Component({
  selector: 'BI-tree',
  templateUrl: './bi-tree.component.html',
  styleUrls: ['./bi-tree.component.scss']
})
export class BITreeComponent implements ITree {

  @ViewChild('treeView') treeViewElem: any;

  @Input() data: any[] = [];
  @Input() DomID: string | undefined;
  @Input() textField: string = '';
  @Input() childrenField: string = '';
  @Input() filterable: boolean = false;
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() selectBy: string = '';
  @Input() selectedKeys: any[] = [];


  @Output() selectionChange = new EventEmitter();
  @Output() blurChange = new EventEmitter();
  @Output() collapeChange = new EventEmitter();
  @Output() expandChange = new EventEmitter();
  @Output() filterChange = new EventEmitter();
  @Output() filterStateChange = new EventEmitter();
  @Output() focusChange = new EventEmitter();

  public filterTerm = "";
  constructor() {
  }

  public onSelectionChange({ index, dataItem }: any): void {
    this.selectedKeys = [{ index, dataItem }];
    this.selectionChange.emit({ keys: this.selectedKeys });
  }

  public onFocus(): void {
    this.focusChange.emit(true);
  }

  public onBlur(): void {
    this.blurChange.emit(true);
  }

  public onExpand(event: any): void {
    this.expandChange.emit(true);
  }

  public onCollapse(event: any): void {
    this.collapeChange.emit(true);
  }

  public onFilterChange(event: string): void {
    this.filterChange.emit(true)
  }

  public onFilterStateChange(event: FilterState): void {
    this.filterStateChange.emit(true);
  }

  public hasChildren = (item: any) => item[this.childrenField] && item[this.childrenField].length > 0;

  public fetchChildren = (item: any) => of(item[this.childrenField]);

  public treeHasNoChildren(): boolean {
    return (this.data.every(i => !this.hasChildren(i)))
  }
}